<template>
  <div>
    <el-tabs v-model="aspType" @tab-click="onTabChange">
      <el-tab-pane label="非ASP" name="0" />
      <el-tab-pane label="ASP" name="1" />
    </el-tabs>
    <div style="margin-bottom: 16px;">
      <el-button type="primary" @click="openImport">导入模板</el-button>
      <el-button @click="handleExport">导出模板</el-button>
    </div>
    <el-card v-for="item in data" :key="item.session_week" class="box-card">
      <el-row>
        <el-col :span="4">
          <div class="card-title card-item">
            <div class="week">{{ item.session_week | getWeek }}</div>
          </div>
        </el-col>
        <el-col :span="16" class="content">
          <el-table :data="item.sessions"
            :header-cell-style="{ background: '#ecf5ff', color: '#606266', 'font-weight': 650 }">
            <el-table-column prop="id" label="场次ID" width="90" />
            <el-table-column prop="session_name" label="场次名称" />
            <el-table-column prop="quota" label="场次名额" width="100">
              <template slot-scope="scope">
                {{ scope.row.quota == -1 ? '不限制' : scope.row.quota }}
              </template>
            </el-table-column>
            <el-table-column prop="session_end_time" label="最后可预约时间" width="120" />
            <el-table-column prop="use_end_time" label="最晚可履约时间" width="120" />
            <el-table-column label="操作" fixed="right" width="120">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="openEdit(scope.row)">修改</el-button>
                <el-button type="text" size="small" @click="handleDelete(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="4">
          <div class="card-item">
            <el-button type="primary" plain @click="openAdd(item)">添加场次</el-button>
          </div>
        </el-col>
      </el-row>
    </el-card>

    <el-dialog :title="form.id ? '修改场次' : '添加场次'" :visible.sync="dialogVisible" width="600px">
      <el-form ref="form" :rules="rules" :model="form" label-width="160px">
        <el-form-item label="场次名称" prop="session_name">
          <el-input v-model="form.session_name" placeholder="请添加场次名称" clearable />
        </el-form-item>
        <el-form-item label="场次名额" prop="quota">
          <el-radio-group v-model="isquota">
            <el-radio :label="true">限额</el-radio>
            <el-radio :label="false">不限额</el-radio>
          </el-radio-group>
          <el-input-number v-if="isquota" v-model="form.quota" :min="0" controls-position="right" />
        </el-form-item>
        <el-form-item label="可预约截止时间" prop="session_end_time">
          <el-time-picker v-model="form.session_end_time" format="HH:mm" value-format="HH:mm" placeholder="选择时间" />
        </el-form-item>
        <el-form-item label="最晚可履约时间" prop="use_end_time">
          <el-time-picker v-model="form.use_end_time" format="HH:mm" value-format="HH:mm" placeholder="选择时间" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false" :disabled="saving">取消</el-button>
        <el-button type="primary" :loading="saving" :disabled="saving" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>

    <ImportDialog
      ref="importDialog"
      v-show="false"
      buttonName="导入模板"
      fileName="导入平台作息模板"
      fileType="upload_platform_repair_sessions"
      :relId="Number(aspType)"
    />
  </div>
</template>
<script>
import {
  getPlatformSessions,
  savePlatformSession,
  deletePlatformSession,
  exportPlatformSessions
} from '../../../api/workandrest'
import ImportDialog from '@/components/importDialog'

export default {
  components: { ImportDialog },
  data () {
    return {
      aspType: '0',
      data: [],
      dialogVisible: false,
      saving: false,
      isquota: true,
      form: {
        id: '',
        session_week: '',
        session_name: '',
        quota: 0,
        session_end_time: null,
        use_start_time: null,
        use_end_time: null
      },
      rules: {
        session_name: [{ required: true, message: '请添加场次名称', trigger: 'blur' }],
        session_end_time: [{ required: true, message: '请选择可预约截止时间', trigger: 'blur' }],
        use_end_time: [{ required: true, message: '请选择最晚可履约时间', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    this.getList()
  },
  filters: {
    getWeek (value) {
      const map = { 1: '周一', 2: '周二', 3: '周三', 4: '周四', 5: '周五', 6: '周六', 7: '周日' }
      return map[value] || ''
    }
  },
  methods: {
    onTabChange () {
      this.getList()
    },
    getList () {
      getPlatformSessions({ asp_type: Number(this.aspType) }).then(res => {
        this.data = res.data.data
      })
    },
    openAdd (item) {
      this.$refs.form && this.$refs.form.resetFields()
      this.isquota = true
      this.form = {
        id: '',
        session_week: item.session_week,
        session_name: '',
        quota: 0,
        session_end_time: null,
        use_start_time: null,
        use_end_time: null
      }
      this.dialogVisible = true
    },
    openEdit (row) {
      this.isquota = row.quota != -1
      this.form = {
        id: row.id,
        session_week: row.session_week,
        session_name: row.session_name,
        quota: row.quota < 0 ? 0 : row.quota,
        session_end_time: row.session_end_time,
        use_start_time: row.use_start_time || null,
        use_end_time: row.use_end_time
      }
      this.dialogVisible = true
    },
    handleSubmit () {
      if (this.saving) return
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const payload = {
          ...this.form,
          asp_type: Number(this.aspType),
          quota: this.isquota ? this.form.quota : -1
        }
        if (!payload.id) delete payload.id
        savePlatformSession(payload).then(() => {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.getList()
        }).finally(() => {
          this.saving = false
        })
      })
    },
    handleDelete (row) {
      this.$confirm('删除后将同步移除各门店对应场次结构，是否继续？', '提示', { type: 'warning' }).then(() => {
        deletePlatformSession({ id: row.id, asp_type: Number(this.aspType) }).then(() => {
          this.$message.success('删除成功')
          this.getList()
        })
      })
    },
    openImport () {
      this.$refs.importDialog.visible = true
    },
    handleExport () {
      exportPlatformSessions({ asp_type: Number(this.aspType) }).then(() => {
        this.$message.success('导出成功，请前往导出列表查看')
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.box-card {
  margin-bottom: 16px;
}
.card-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80px;
}
.week {
  font-size: 16px;
  font-weight: 600;
}
</style>
